import type { ReactNode } from 'react';
import { Terminal } from '@/components/ui';
import { Header } from '../Header';
import { Footer } from '../Footer';
import styles from './Shell.module.css';

interface ShellProps {
  children: ReactNode;
}

/**
 * Main shell layout component.
 *
 * Provides the DOS-style terminal frame around the entire application.
 * Includes header navigation and footer status bar.
 */
export function Shell({ children }: ShellProps) {
  return (
    <div className={styles.shell}>
      <Terminal>
        <div className={styles.layout}>
          <Header />
          <main className={styles.main}>
            {children}
          </main>
          <Footer />
        </div>
      </Terminal>
    </div>
  );
}
